'use strict';

Object.defineProperty(exports, "__esModule", {
	value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _ramda = require('ramda');

var _WMRaisedButton = require('../WMRaisedButton');

var _WMRaisedButton2 = _interopRequireDefault(_WMRaisedButton);

var _styles = require('./styles');

var _styles2 = _interopRequireDefault(_styles);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var propTypes = {
	actions: _propTypes2.default.node,
	actionStyles: _propTypes2.default.object,
	fieldStyles: _propTypes2.default.object,
	children: _propTypes2.default.node.isRequired,
	disabled: _propTypes2.default.bool,
	onSubmit: _propTypes2.default.func.isRequired,
	submitText: _propTypes2.default.string
};

var WMValidatingForm = function (_Component) {
	_inherits(WMValidatingForm, _Component);

	function WMValidatingForm(props) {
		_classCallCheck(this, WMValidatingForm);

		var _this = _possibleConstructorReturn(this, (WMValidatingForm.__proto__ || Object.getPrototypeOf(WMValidatingForm)).call(this, props));

		_this.onValidate = function (_ref) {
			var name = _ref.name,
			    value = _ref.value,
			    isValid = _ref.isValid;

			_this.setState(_defineProperty({}, name, { value: value, isValid: isValid }));
		};

		_this.handleSubmit = function () {
			var form = (0, _ramda.map)(function (x) {
				return x.value;
			}, _this.state);

			_this.props.onSubmit(form);
		};

		_this.isFormValid = function () {
			return Object.keys(_this.state).every(function (field) {
				return _this.state[field].isValid;
			});
		};

		_this.state = {};
		return _this;
	}

	_createClass(WMValidatingForm, [{
		key: 'getChildContext',
		value: function getChildContext() {
			return {
				onValidate: this.onValidate
			};
		}
	}, {
		key: 'render',
		value: function render() {
			var _props = this.props,
			    actions = _props.actions,
			    actionStyles = _props.actionStyles,
			    fieldStyles = _props.fieldStyles,
			    children = _props.children,
			    _props$disabled = _props.disabled,
			    disabled = _props$disabled === undefined ? false : _props$disabled,
			    submitText = _props.submitText;


			return _react2.default.createElement(
				'div',
				null,
				_react2.default.createElement(
					'div',
					{
						'data-component-identifier': 'wm-validating-form__fields',
						style: Object.assign({}, _styles2.default.fields, fieldStyles)
					},
					children
				),
				_react2.default.createElement(
					'footer',
					{
						'data-component-identifier': 'wm-validating-form__actions',
						style: Object.assign({}, _styles2.default.actions, actionStyles)
					},
					actions,
					_react2.default.createElement(_WMRaisedButton2.default, {
						'data-component-identifier': 'wm-validating-form__submit',
						primary: true,
						label: submitText || 'Submit',
						disabled: !this.isFormValid() || disabled,
						onClick: this.handleSubmit
					})
				)
			);
		}
	}]);

	return WMValidatingForm;
}(_react.Component);

WMValidatingForm.childContextTypes = {
	onValidate: _propTypes2.default.func
};

exports.default = WMValidatingForm;


// WEBPACK FOOTER //
// ./~/@workmarket/front-end-components/dist/WMValidatingForm/index.js